// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  eventId: __t.u64().primaryKey().name("event_id"),
  battleId: __t.u64().name("battle_id"),
  worldId: __t.u64().name("world_id"),
  seq: __t.u32(),
  kind: __t.string(),
  actorId: __t.u64().name("actor_id"),
  targetId: __t.u64().name("target_id"),
  x: __t.f32(),
  z: __t.f32(),
  tx: __t.f32(),
  tz: __t.f32(),
  weaponKey: __t.string().name("weapon_key"),
  dmg: __t.i32(),
  detail: __t.string(),
  at: __t.timestamp(),
});
